import { CaseMetaType } from "interfaces/case-meta-type";
import { useLazyFetchV2 } from "hooks/fetch/useLazyFetchV2";

interface LazyFetchResponse {
  count?: number;
  results?: CaseMetaType[];
}

interface LazyFetchFailureType {
  loading: boolean;
  error: boolean;
  fetchCallback: (url: string) => Promise<LazyFetchResponse>;
}

export const useLazyGetCaseMetaTypes = (): {
  loading: boolean;
  error: boolean;
  fetchCaseMetaTypes: (queryString?: string) => Promise<LazyFetchResponse>;
} => {
  const {
    loading,
    error,
    fetchCallback
  }: LazyFetchFailureType = useLazyFetchV2("GET");

  return {
    loading,
    error,
    fetchCaseMetaTypes: (queryString?: string) =>
      fetchCallback(`case_meta_types?${queryString ?? ""}`)
  };
};
